export const lightGradient = ['#9B4C7E', '#EB3B41', '#F47132', '#FACC35'];
